const { REACT_APP_PROXY_HOST } = process.env;
const ENDPOINT_COCKPIT_SYNCSTATSREF = (REACT_APP_PROXY_HOST || '') + '/monitoring/cockpit/syncstatsref';

export async function chargerCockpitSyncStatsRef() {
  const reponse = await fetch(ENDPOINT_COCKPIT_SYNCSTATSREF, { method: 'GET' });
  const texte = await reponse.text();
  if (!reponse.ok) {
    throw new Error(`HTTP ${reponse.status} — ${ENDPOINT_COCKPIT_SYNCSTATSREF}`);
  }
  return JSON.parse(texte);
}



// WEBPACK FOOTER //
// src/components/cockpit/cockpitSyncStatsRefApi.js